import { FormErrors, FormPayload } from '../types';
import { FieldNames } from '../../../../Interfaces/Auth';

export const validate =
  (initialValues: FormPayload) =>
  (values: Partial<FormPayload>): FormErrors => {
    const errors: FormErrors = {};

    if (
      !values[FieldNames.Email] &&
      values[FieldNames.Email] !== initialValues[FieldNames.Email]
    ) {
      errors[FieldNames.Email] = 'Required';
    }
    if (
      !values[FieldNames.Password] &&
      values[FieldNames.Password] !== initialValues[FieldNames.Password]
    ) {
      errors[FieldNames.Password] = 'Required';
    }
    // if (!values[FieldNames.RememberMe]) {
    //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //   // @ts-expect-error
    //   errors[FieldNames.RememberMe] = 'Required';
    // }

    return errors;
  };
